/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CloseTabDto } from '../../models/close-tab-dto';
import { PosTab } from '../../models/pos-tab';

export interface PosTabsControllerCloseTab$Params {
  id: string;
      body: CloseTabDto
}

export function posTabsControllerCloseTab(http: HttpClient, rootUrl: string, params: PosTabsControllerCloseTab$Params, context?: HttpContext): Observable<StrictHttpResponse<PosTab>> {
  const rb = new RequestBuilder(rootUrl, posTabsControllerCloseTab.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PosTab>;
    })
  );
}

posTabsControllerCloseTab.PATH = '/pos/tabs/{id}/close';
